function uniqueMerge(existing, incoming) {
  const values = new Set([...(existing || []), ...(incoming || [])]);
  return Array.from(values).filter(
    (value) => value !== undefined && value !== null
  );
}

function compactObject(value) {
  return Object.fromEntries(
    Object.entries(value).filter(([_key, entry]) => entry !== undefined)
  );
}

export function createBuyerIntentCore() {
  const pageState = {
    productIds: [],
    categoryIds: [],
    tag: undefined,
    sourceLocation: undefined,
    context: {},
  };

  const baseState = {
    origin: undefined,
    distinctId: undefined,
    userType: 'standard',
  };

  const visitState = {
    properties: {},
  };

  function setBaseProperties(options = {}) {
    if (options.origin) {
      baseState.origin = options.origin;
    }

    if (options.distinctId) {
      baseState.distinctId = options.distinctId;
    }

    if (options.userType) {
      baseState.userType = options.userType;
    }
  }

  function setVisitProperties(options = {}) {
    if (options && typeof options === 'object') {
      visitState.properties = { ...visitState.properties, ...options };
    }
  }

  function tagPage(options = {}) {
    pageState.productIds = uniqueMerge(
      pageState.productIds,
      options.productIds || []
    );
    pageState.categoryIds = uniqueMerge(
      pageState.categoryIds,
      options.categoryIds || []
    );

    if (options.tag) {
      pageState.tag = options.tag;
    }

    if (options.sourceLocation) {
      pageState.sourceLocation = options.sourceLocation;
    }

    if (options.context && typeof options.context === 'object') {
      pageState.context = { ...pageState.context, ...options.context };
    }
  }

  function resetPageState() {
    pageState.productIds = [];
    pageState.categoryIds = [];
    pageState.tag = undefined;
    pageState.sourceLocation = undefined;
    pageState.context = {};
  }

  function buildPayload({
    name,
    url,
    origin,
    distinctId,
    userType,
    visit = {},
  }) {
    const resolvedContext = Object.keys(pageState.context).length
      ? pageState.context
      : undefined;
    const properties = compactObject({
      product_ids: pageState.productIds,
      category_ids: pageState.categoryIds,
      tag: pageState.tag,
      url,
      user_type: userType || baseState.userType,
      distinct_id: distinctId || baseState.distinctId,
      origin: origin || baseState.origin,
      source_location: pageState.sourceLocation,
      context: resolvedContext,
    });

    const visitProperties = compactObject({
      landing_page: visit.landingPage,
      referrer: visit.referrer,
      user_agent: visit.userAgent,
      utm_source: visit.utmParams?.utm_source,
      utm_medium: visit.utmParams?.utm_medium,
      utm_campaign: visit.utmParams?.utm_campaign,
      utm_term: visit.utmParams?.utm_term,
      utm_content: visit.utmParams?.utm_content,
      ...visitState.properties,
    });

    return compactObject({
      name,
      properties,
      visit: Object.keys(visitProperties).length
        ? { properties: visitProperties }
        : undefined,
    });
  }

  return {
    setBaseProperties,
    setVisitProperties,
    tagPage,
    resetPageState,
    buildPayload,
  };
}
